import { Group, Stack, Text } from "@mantine/core";
import type { ReactNode } from "react";

export default function SettingsSectionItem({
  title,
  description,
  children
}: {
  title: string;
  description?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Group justify="space-between" align="center">
      <Stack gap={5}>
        <Text fw={600} size="sm">
          {title}
        </Text>
        {description && (
          <Text c="dimmed" maw={800} size={"sm"}>
            {description}
          </Text>
        )}
      </Stack>
      {children}
    </Group>
  );
}
